



























import { mapState } from "vuex";

import { Component, Vue, Watch } from "vue-property-decorator";

import { Route } from "vue-router";
import { Tenant } from "@/interfaces/tenants";

import { TenantApiClient } from "@/api/tenant_client";
import VideoContent from "@/components/VideoContent.vue";

@Component({
  computed: {
    ...mapState(["tenants", "contents"])
  },
  components: { VideoContent }
})
export default class TenantCreateVideo extends Vue {
  // Mapped from vuex
  tenants!: Tenant[];
  contents!: any;

  // Other Variables
  private api = new TenantApiClient();

  public breadcrumbs: any[] = [];
  public isLoading = true;

  public data = {
    content: {} as any,
    tenant: {} as any
  };

  async mounted() {
    this.setTenant(this.$route.params.tenant_id);
    await this.setContent(this.$route.params.tenant_id);
  }

  // Watchers
  @Watch("$route")
  async onRouteChange(newValue: Route) {
    this.setTenant(newValue.params.tenant_id);
    await this.setContent(newValue.params.content_id);
  }

  async setContent(tenantId: string) {
    this.data.content = await this.api.addVideo(tenantId);
    this.contents[this.data.content.content_id] = this.data.content;
  }

  setTenant(tenantId: string) {
    this.tenants.forEach(tenant => {
      if (tenant.tenant_id === tenantId) {
        this.data.tenant = tenant;

        this.$store.commit("clearBreadcrumbs");
        this.$store.commit("pushBreadcrumbs", {
          to: `/tenant/${tenantId}`,
          label: tenant.name
        });
        this.$store.commit("pushBreadcrumbs", {
          to: `/tenant/${tenantId}/videos`,
          label: "Videos"
        });
        this.$store.commit("pushBreadcrumbs", {
          label: "Neues Video"
        });
      }
    });
  }

  async save() {
    try {
      const newContent = await this.api.saveContent(
        this.data.tenant.tenant_id,
        this.data.content
      );

      // this.contents[newContent.content_id] = newContent;
      // this.data.original = this.contents[newContent.content_id];
      // this.data.content = JSON.parse(JSON.stringify(this.data.original));

      this.$buefy.toast.open({
        message: "Content updated.",
        type: "is-info",
        queue: false
      });
    } catch (e) {
      this.$buefy.toast.open({
        message: "Problem updating content.",
        type: "is-danger",
        queue: false
      });
    }
  }

  reset() {
    this.$buefy.dialog.confirm({
      title: "Verwerfen?",
      message: "Möchtest du das neue Video wirklich verwerfen?",
      confirmText: "Verwerfen",
      type: "is-danger",
      hasIcon: true,
      onConfirm: async () => {
        await this.api.deleteContent(
          this.data.tenant.tenant_id,
          this.data.content.content_id
        );

        this.contents[this.data.content.content_id] = undefined;
        await this.$router.push(`/tenant/${this.data.tenant.tenant_id}/videos`);
      }
    });
  }
}
